import { render, staticRenderFns } from "./KeyPoints.vue?vue&type=template&id=a1c0a64a&scoped=true&"
import script from "./KeyPoints.vue?vue&type=script&lang=js&"
export * from "./KeyPoints.vue?vue&type=script&lang=js&"
import style0 from "./KeyPoints.vue?vue&type=style&index=0&id=a1c0a64a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0a64a",
  null
  
)

export default component.exports